<script setup lang="ts">
import { ref } from "vue";
import DRBtnIcon from "../UI/DRBtnIcon.vue";
import ProjectsArchivesList from "./ProjectsArchivesList.vue";

const props = withDefaults(
  defineProps<{
    projectId: number;
  }>(),
  {}
);

const isVisible = ref(false);
</script>

<template>
  <el-dropdown trigger="click" @visible-change="isVisible = $event">
    <DRBtnIcon variant="flat" :size="35" icon="bi-archive"> </DRBtnIcon>
    <template #dropdown>
      <ProjectsArchivesList v-if="isVisible" :projectId="props.projectId" />
    </template>
  </el-dropdown>
</template>
